import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import {
  PromptItem,
  PromptDocuments,
} from '../../../../types/candidateStories';
import { findItemTranslation } from './promptGroupHelpers';
import FilePromptUploadSection from './FilePromptUploadSection';

const FilePromptItem = ({
  item,
  promptDocuments,
  remove,
  recordId,
}: {
  item: PromptItem;
  promptDocuments: PromptDocuments;
  remove: (index: number, field: string) => void;
  recordId?: string;
}) => {
  const currentLanguage = i18n.getLocale();
  const translatedItem = findItemTranslation(item, currentLanguage);
  const field = recordId
    ? `candidateStories.promptGroup.${recordId}.${item.id}.documents`
    : `candidateStories.promptGroup.general.${item.id}.documents`;

  if (!promptDocuments[item.id]?.documents) {
    promptDocuments[item.id] = { documents: [] };
  }

  const removeDocuments = (index: number) => {
    remove(index, field);
  };

  return (
    <div key={item.id} data-testid={`file-prompt-item-${item.id}`}>
      <h5 className='mb-2'>
        {translatedItem?.title}
        {item.required && <span className='text-danger'> *</span>}
      </h5>
      <p className='text-muted mb-2'>{translatedItem?.description}</p>
      <FilePromptUploadSection
        item={item}
        documents={promptDocuments[item.id].documents}
        onRemove={removeDocuments}
        field={field}
      />
    </div>
  );
};

export default FilePromptItem;
